module.exports = __webpack_public_path__ + "img/avatar.07d9c996.png";